export const getProductRequest = (type) => {
  switch (type?.toLowerCase()) {
    case "delivery": return ["DELIVERY", "STORAGE_TO_DELIVERY"];
    case "storage": return ["STORAGE"];
    case "sell-back": return ["SELL_BACK"];
    default : return [];
  }
};
